var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-[8px] bg-[#F0EFF3] py-[4px] relative px-[8px]"},[_c('div',{staticClass:"rounded-[8px] h-[7px]",style:({width: _vm.percent+'%',backgroundColor: _vm.getColorByPercent(_vm.percent)})}),_c('div',{staticClass:"text-11 font-medium absolute top-0 pl-[10px]",style:({left: _vm.percent+'%'})},[_vm._v(_vm._s(_vm.ratio))])])
}
var staticRenderFns = []

export { render, staticRenderFns }